"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryVoronoi", {
  enumerable: true,
  get: function () {
    return _victoryVoronoi.default;
  }
});
Object.defineProperty(exports, "Voronoi", {
  enumerable: true,
  get: function () {
    return _voronoi.default;
  }
});

var _victoryVoronoi = _interopRequireDefault(require("./victory-voronoi"));

var _voronoi = _interopRequireDefault(require("./voronoi"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-voronoi/lib/index.js
// module id = 1908
// module chunks = 0